module.exports = __webpack_public_path__ + "media/mine.a04518ae.wav";